import type { BooksyEppoInstance } from './types'
import {
  EppoFeatureFlags,
  EppoExperiments,
} from './consts'

export const createEppoFallbackInstance = (): BooksyEppoInstance => {
  const ff = (flag: string): boolean | string => {
    return (EppoFeatureFlags as Record<string, { defaultValue: boolean | string }>)[flag]?.defaultValue as boolean | string
  }

  const experiment = (experimentName: string): string | boolean => {
    return (EppoExperiments as Record<string, { defaultValue: string | boolean }>)[experimentName]?.defaultValue as string | boolean
  }

  const on = (): void => { /* do nothing */ }

  return {
    ff,
    experiment,
    on,
  }
}
